import { AlertCircle } from "lucide-react";

import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert";

import { Button } from "@/components/ui/button";

interface ErrorProps {
  title?: string;
  message?: string;
  action?: {
    label: string;
    onClick: () => void;
  };
  className?: string;
  children?: React.ReactNode;
}

const ErrorComponent = ({
  title = "Error",
  message,
  action,
  children,
}: ErrorProps) => {
  return (
    <Alert className="self-start p-[1rem]" variant="destructive">
      <AlertCircle className="h-12 w-12" />
      <AlertTitle className="text-xl">{title}</AlertTitle>
      <AlertDescription>
        {message && <p>{message}</p>}
        {children}
        {action && (
          <Button variant="destructive" onClick={action.onClick}>
            {action.label}
          </Button>
        )}
      </AlertDescription>
    </Alert>
  );
};

export default ErrorComponent;
